





import { Component, Vue } from 'vue-property-decorator';
import { Dialog } from 'vant';
import { TheGlobalApi } from '@/api/global.api';
@Component
export default class App extends Vue {
  // async getCutomer() {
  //   const res: any = await TheGlobalApi.customer({});
  //   if (!res) return;
  //   this.$store.commit('setCustomer', res);
  // }
  // created() {
  //   this.getCutomer();
  // }
}
